import { useContext, useState } from "react";
import { USERS_PATH } from "../../functions/src/admin/paths";
import { auth, mainDatabase, schoolDatabase } from "../api/firebase";
import { langContext } from "../api/Lang";
import { captureException } from "../api/sentry";
import { useStrings } from "../common-strings";
import { useSettingsStrings } from "../Order/profile/settings-strings";


export default function SettingsHook() {

    const commonStrings = useStrings();
    const settingsStrings = useSettingsStrings();

    var user = auth.currentUser;

    const [lang, setLang] = useContext(langContext);

    const [dlgSignOut, setDlgSignOut] = useState(false);
    const onSignOut = async () => {
        setDlgSignOut(true);
    }


    const deleteAccount = () => {
        const uidToDelete = auth.currentUser.uid;
        auth.currentUser?.delete().then(async function () {
            try {
                await mainDatabase.ref(USERS_PATH).child(uidToDelete).remove();
                await schoolDatabase.ref(USERS_PATH).child(uidToDelete).remove();
                confirm(settingsStrings.dlgAccountDeleted);
            } catch (error) {
                captureException(error instanceof Error ? error : new Error(String(error)), {
                    tags: { component: 'SettingsHook', operation: 'deleteAccount_cleanup' },
                    extra: { uid: uidToDelete },
                });
            }
        }).catch(function (error) {
            captureException(error instanceof Error ? error : new Error(String(error)), {
                tags: { component: 'SettingsHook', operation: 'deleteAccount_auth' },
                extra: { uid: uidToDelete },
            });
        });
    }

    const reAuthenticate = () => {
        var credential;
        // TODO: Get credential
        user.reauthenticateWithCredential(credential).then(function () {
            deleteAccount();
        }).catch(function (error) {
            console.log(error);
        });
    }
    const onDeleteAccount = () => {
        if (confirm(settingsStrings.dlgDeleteAccount)) {
            reAuthenticate();
        }
    }

    return { commonStrings, lang, setLang, dlgSignOut, setDlgSignOut, signOutDlgTitle: settingsStrings.signOutDlgTitle, onSignOut, onDeleteAccount };
}